import { useState } from 'react'

function useCreateJob() {
    const [jobCreateError, setJobCreateError] = useState();
    const [jobCreating, setJobCreating] = useState();

    const createJob = async (type) => {
        const confirm = window.confirm("Are you sure to make new job?");
        if (!confirm) return;
        setJobCreating(true);
        setJobCreateError(null);
        try {
            const res = await fetch(`/sis/${type}`, { method: 'post' });
            setJobCreating(false);
            if (res.ok) return true;
        } catch (error) {
            setJobCreateError(error && error.message);
            setJobCreating(false);
        }
    }

    return { createJob, jobCreateError, jobCreating };
}

export default useCreateJob
